export default __webpack_public_path__ + "static/media/1-12@2x.e904d556.png";